const NFO_FUND_DETAILS = {
  pageDataAid: "nfoDetailPage",
  navigationHeaderDataAid: "1",
  basicDetails: {
    dataAid: "basicDetails",
    titleDataAid: "title",
  },
  validity: {
    text: "Validity period",
    keyDataAid: "validityKey",
    valueDataAid: "validityValue",
  },
  risk: {
    text: "Allotment date",
    keyDataAid: "allotmentDateKey",
    valueDataAid: "allotmentDateValue",
  },
  date: {
    text: "Lock in",
    keyDataAid: "lockInKey",
    valueDataAid: "lockInValue",
  },
  overview: {
    dataAid: "overview",
    title: "Overview",
    detailsDataAid: "details",
  },
  moreDetails: {
    dataAid: "moreDetails",
    title: {
      text: "More Details",
    },
    exitLoad: {
      title: {
        text: "Exit load",
        dataAid: "exitLoadTitle",
      },
      subTitle: {
        dataAid: "exitLoadSubtitle",
      },
    },
    redemption: {
      title: {
        text: "Redemption disclosure",
        dataAid: "redemptionTitle",
      },
      subTitle: {
        dataAid: "redemptionSubtitle",
      },
    },
    readMore: {
      title: {
        text: "Read more",
        dataAid: "readMoreTitle",
      },
      button: {
        dataAid: "linkSmall",
      },
    },
  },
  cta: {
    text: "INVEST",
    dataAid: "primary",
  },
};
export default NFO_FUND_DETAILS;
